import { PHONE_NUMBER_WILDCARD } from '@/features/PhoneNumberSearch/constants';

type HighlightedTitleSegment = {
  text: string;
  highlighted: boolean;
};

export function getHighlightedTitleSegments(
  title: string,
  filter: string
): HighlightedTitleSegment[] | null {
  const digitIndices = [...title.matchAll(/\d/g)].map(({ index }) => index);
  const highlightIndices = filter
    .split('')
    .reduce<Set<number>>((acc, char, i) => {
      const index = digitIndices[i];
      return char !== PHONE_NUMBER_WILDCARD && index !== undefined
        ? acc.add(index)
        : acc;
    }, new Set());

  if (!highlightIndices.size) {
    return null;
  }

  return title
    .split('')
    .reduce<HighlightedTitleSegment[]>((segments, char, i) => {
      const isHighlighted = highlightIndices.has(i);
      const last = segments[segments.length - 1];

      if (last?.highlighted === isHighlighted) {
        return [
          ...segments.slice(0, -1),
          { text: last.text + char, highlighted: isHighlighted },
        ];
      }

      return [...segments, { text: char, highlighted: isHighlighted }];
    }, []);
}
